import React from "react";

import styles from "./../underwriting.module.scss";

type DataBlockProps = {
	id?: string;
	data?: { label: string; value: string }[][];
};

const DataBlock = ({ id, data }: DataBlockProps) => (
	<ul className={styles.dataBlock}>
		{data?.map((dataItem, dataItemIndex) => {
			return (
				<li key={`${id}${dataItemIndex}`}>
					{dataItem.map((item, index) => (
						<div
							key={`${id}${dataItemIndex}${index}`}
							className={styles.line}
						>
							<span className="text-muted">{item.label}: </span>
							{item.value}
						</div>
					))}
				</li>
			);
		})}
	</ul>
);

export default DataBlock;
